import { TagColorKind } from "generated/graphql";

// This is a common ground between TagView and FieldValueGroupTag for rendering/sorting
export interface DisplayTag {
  systemName: string;
  displayName: string;
  description?: string | null;
  colorValue?: string;
  color: TagColorKind;
  rank: number;
}

export interface DisplayTagWithCount extends DisplayTag {
  count: number;
}

export function hasCount(tag: DisplayTag): tag is DisplayTagWithCount {
  return "count" in tag;
}

export interface EntryContext {
  valueGroupId: number;
  referenceId?: number;
  page?: number;
}
